// src/App.js
import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import AccessAccount from "./components/Auth/AccessAccount";
import Navbar from "./components/common/Navbar";
import PrivateRoute, { AuthRoute } from "./components/common/PrivateRoute";
import Dashboard from "./components/Dashboard/Dashboard";
import Users from "./components/Users/Users";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { UserDataProvider } from "./contexts/UserDataContext";
import LoadingScreen from "./components/LoadingScreen";

function App() {
  return (
    <Router>
      <AuthProvider>
        <UserDataProvider>
          <AppRoutes />
        </UserDataProvider>
      </AuthProvider>
    </Router>
  );
}

const AppRoutes = () => {
  const { loading } = useAuth();

  // Show the loading screen at the app level during initial load
  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Navbar />
      <Routes>
        {/* Public Routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/access-account"
          element={
            <AuthRoute>
              <AccessAccount />
            </AuthRoute>
          }
        />

        {/* Private Routes */}
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        {/* terms-of-service */}

        {/* about */}

        {/* Default route redirect to home */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

export default App;
